var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadRenter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 10H20L17.65 7.65002C17.0167 7.01669 16.1667 6.66669 15.2833 6.66669H6.66667C4.83333 6.66669 3.35 8.16669 3.35 10L3.33333 30C3.33333 31.8334 4.83333 33.3334 6.66667 33.3334H33.3333C35.1667 33.3334 36.6667 31.8334 36.6667 30V13.3334C36.6667 11.5 35.1667 10 33.3333 10ZM21.6667 21.6667V26.6667C21.6667 27.5834 20.9167 28.3334 20 28.3334C19.0833 28.3334 18.3333 27.5834 18.3333 26.6667V21.6667H15.35C14.6 21.6667 14.2333 20.7667 14.7667 20.25L19.4333 15.6C19.7667 15.2667 20.2833 15.2834 20.6167 15.6L25.2667 20.25C25.7667 20.7667 25.4 21.6667 24.6667 21.6667H21.6667Z",
    fill: "#829AB1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadRenter);
export default __webpack_public_path__ + "static/media/upload-renter.2d9cce00fedb95957e16c3ae8caf6a36.svg";
export { ForwardRef as ReactComponent };